import { render, staticRenderFns } from "./Especialidad.vue?vue&type=template&id=1be94d41"
import script from "./Especialidad.vue?vue&type=script&lang=ts"
export * from "./Especialidad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports